import { IconCloudSync } from '@components/icons/cloud-sync';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { pxToRem } from '@utils/converters';

type ListOptionLabelProps = {
  name: string;
  isSynced: boolean;
  isSyncActive?: boolean;
  tooltip?: string;
};

export const ListOptionLabel = ({
  name,
  isSynced,
  isSyncActive,
  tooltip,
}: ListOptionLabelProps) => {
  if (!isSynced) return <>{name}</>;

  return (
    <Stack orientation="horizontal" align="center" justify="space-between">
      <Text font="regular14" text={name} ellipsis />
      <IconCloudSync
        className="synced-icon"
        size={16}
        color={isSyncActive ? 'green100' : 'buttonIconPositive'}
        style={{ marginLeft: pxToRem(8) }}
        tooltip={tooltip}
      />
    </Stack>
  );
};
